export const ADMINISTRACAO = () => '/administracao';
